import { Component, OnInit } from '@angular/core';
import {FormArray, FormControl, FormGroup} from "@angular/forms";

interface chipElement {
  arrayString: string[];
  formArrayName: string;
}

@Component({
  selector: 'app-chips-list',
  templateUrl: './chips-list.component.html',
  styleUrls: ['./chips-list.component.scss']
})
export class ChipsListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Add a chip and the value into the form control
   * @param value, the value to add
   * @param array, the array from the component.ts
   * @param formArrayName, the name of the formArray in the form
   * @param formControl, ...
   * @param form, ...
   * @param inci, Boolean indicating if we are dealing with an INCI or not
   */
  public addChip(value, viewValue, array, formArrayName, formControl, form, inci:boolean) {

    if (inci) value = value.toUpperCase();
    if (!viewValue) viewValue = value;

    const contains = array.includes(viewValue); //Check if the chip has already been added in the array

    //Get the formArray from the formBuilder
    const formArrayValues = (form.get(formArrayName) as FormArray);

    // Add our INCI to the formControl
    if ((value || '').trim() && !contains) {
      //this.INCIs.push(value);
      array.push(viewValue);
      formArrayValues.push(new FormControl(value));
    }

    formControl.setValue(null);

  }

  /**
   * Remove a chip and the value form the formControl
   * @param value, The value to remove
   */
  remove(value: string,array, formArrayName, form): void {
    const index = array.indexOf(value);

    //Get the formArray of the element from the formBuilder
    const formArrayValues = (form.get(formArrayName) as FormArray);

    if (index >= 0) {
      array.splice(index, 1);
      formArrayValues.removeAt(index);
    }
  }

  /**
   * Clear a chip element, both the input and the form linked to it
   * @param {chipElement} chipElement, The chip element to clear
   */
  clearChipElement(chipElement:chipElement, form: FormGroup) {
    var formArray = (form.get(chipElement.formArrayName) as FormArray);
    formArray.clear() //Empty the FormArray
    chipElement.arrayString = [] //Empty the array to remove the things that have been typed in the input, if any had been typed
  }

}
